import React, {Fragment, useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ListItemButton from '@mui/material/ListItemButton';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import LockClockIcon from '@mui/icons-material/LockClock';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Popover from '@mui/material/Popover';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import AddchartIcon from '@mui/icons-material/Addchart';
import { useNavigate } from 'react-router-dom';
import { setCopyings } from '../../request/Analysis/hitorySlice';
import { useDispatch } from 'react-redux';
import { useMutation } from "react-query";
import apiClient from "../../request/http-common";
import { Currency } from '@depay/local-currency';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import ReactApexChart from 'react-apexcharts';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import CircularProgress from '@mui/material/CircularProgress';
import SmallChart from './SmallChart';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TraderSingle = () => {
  
  const formatInvestors = (count) => {
    count = parseInt(count);
    if (count >= 1000000) {
        return (count / 1000000).toFixed(1) + 'M';
    } else if (count >= 1000) {
        return (count / 1000).toFixed(1) + 'K';
    }
    return count;
  };

  const user = useSelector((state) => state.user.user);
  const coinRates = useSelector((state) => state.coins.coinRates);
  const addresses = useSelector((state) => state.coins.addresses);
  const appMode = useSelector((state) => state.mode.mode);
  const params = useParams();
  const dispatch = useDispatch();
  const [rate, setRate] = useState(1);

  const calculateBalance = (coin) => coin.balance === null ? 0 : coin.balance

  const [traderId, settraderId] = useState();
  const [selectedtrader, setSelectedtrader] = useState('');
  const [source, setSource] = useState('');
  const [proportion, setProportion] = useState('');
  const [error, setErros] = useState('');
  const navigate = useNavigate();

  const callRate = async()=> {
    if(user.currency === 'USD'){
      setRate(1);
    }else{
      await Currency.fromUSD({ amount: 1 }).then(amount=>{
        setRate(amount.amount);
       });
    }  
  };

  const traders = useSelector((state) => state.traders.traders);
  const getDate = (date) => new Date(date).toLocaleString('en-GB', {
    hour12: false,
  });

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const calcPercentage = (profit, loss) => {
    let total = parseFloat(profit) + parseFloat(loss);
    let percent = profit/total;
    return percent * 100;
  }
 
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  const [buttonText, setbuttonText] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState(null);

  const getCoinDetails = (coinName) => {
    switch (coinName) {
      case 'Overall Asset':
        setSelectedCoin(null) 
        break;
      case 'Referral Wallet':
        setSelectedCoin(null) 
        break;
      default:
        addresses.forEach(address => {
          if (address.coin_name === coinName) {       
            setSelectedCoin(address)            
          }
        });
        break;
    }
  }

  const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
    async () => {
      return await apiClient.post(`/api/store-copy`, {
        trader_id: traderId,
        amount: amount, 
        proportion: proportion,
        payment_source: source
      });
    },
    {
      onSuccess: (res) => {
          if (res.data.status === 'success') {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            dispatch(setCopyings(res.data.investments));
            setTimeout(() => {
              navigate('/copy-history');
            }, 2000);
          }            
      },
      onError: (err) => {
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
              setErros(myerror.errors)               
            }else{
                let errorMessage = err.response?.data.message || err ;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
            }
      },
    }
  );

  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = useState(0);
  const [currentTrader, setcurrentTrader] = useState(null);

  const fundingBal = useSelector((state) => state.wallet.fundingBalance);
  const subBal = useSelector((state) => state.wallet.subscriptionBalance);
  const refBal = useSelector((state) => state.wallet.referralBalance);
  const mainBal = useSelector((state) => state.wallet.withdrawableBalance);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getRiskColor = (riskScore) => {
    const score = parseInt(riskScore);
    if (score <= 3) return '#4caf50'; // Low risk - Green
    if (score <= 5) return '#ff9800'; // Medium risk - Orange
    return '#f44336'; // High risk - Red
  };

  const getRiskLabel = (riskScore) => {
    const score = parseInt(riskScore);
    if (score <= 3) return 'Low Risk';
    if (score <= 5) return 'Medium Risk';
    return 'High Risk';
  };

  const getSeriesdata = (targetPercentage) => {
    let data = [];
    const now = new Date();
    const sevenDaysAgo = new Date(now.getTime() - (7 * 24 * 60 * 60 * 1000));
    
    let currentPercentage = 0;
    for (let i = 0; i < 7; i++) {
      const date = new Date(sevenDaysAgo.getTime() + (i * 24 * 60 * 60 * 1000));
      
      const remainingDays = 7 - i;
      const averageStepNeeded = (targetPercentage - currentPercentage) / remainingDays;
      const randomStep = averageStepNeeded * (0.5 + Math.random());
      
      currentPercentage += randomStep;
      
      const variation = targetPercentage * 0.05;
      const value = currentPercentage + (variation * (Math.random() - 0.5));
      
      data.push({
        x: date.getTime(),
        y: parseFloat(value.toFixed(2))
      });
    }
    
    return data;
  };

  const options = {
    chart: {
      type: 'area',
      height: 350,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    grid: {
      borderColor: '#90A4AE20',
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: true,
          opacity: 0.1
        }
      },
      yaxis: {
        lines: {
          show: true,
          opacity: 0.1
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      colors: ['#22c55e']
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 90, 100],
        colorStops: [
          {
            offset: 0,
            color: '#22c55e',
            opacity: 0.4
          },
          {
            offset: 100,
            color: '#22c55e',
            opacity: 0.1
          }
        ]
      }
    },
    colors: ['#22c55e'],
    title: {
      text: 'Investment Performance',
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 'bold'
      }
    },
    xaxis: {
      type: 'datetime',
      labels: {
        formatter: function(val) {
          return new Date(val).toLocaleDateString();
        }
      }
    },
    yaxis: {
      labels: {
        formatter: function(val) {
          return val.toFixed(2) + '%';
        }
      }
    },
    tooltip: {
      theme: appMode,
      x: {
        format: 'dd MMM yyyy'
      },
      style: {
        fontSize: '12px',
        fontFamily: undefined
      },
      y: {
        formatter: function(value) {
          return value + '%'
        }
      }
    }
  };

  return (
    <div style={{marginTop: '75px'}}>
      <Box sx={{paddingX: '10px'}}>
        {traders.map(trader => (
          parseInt(trader.id) === parseInt(params.id) &&
          <Fragment key={trader.id}>
            {/* Hero Section */}
            <Card sx={{ 
              mb: 3, 
              borderRadius: '16px',
              background: appMode === 'dark' 
                ? 'rgba(255,255,255,0.02)' 
                : 'rgba(0,0,0,0.02)',
              border: appMode === 'dark'
                ? '1px solid rgba(255,255,255,0.08)'
                : '1px solid rgba(0,0,0,0.06)',
            }}>
              <CardContent sx={{ p: 3 }}>
                {/* Title Section */}
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {trader.trader_name}
                  </Typography>
                </Box>

                {/* Avatar and Button Section */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Avatar 
                    alt="Investment Manager" 
                    src={trader.image} 
                    sx={{ width: 80, height: 80, border: '3px solid rgba(34, 197, 94, 0.2)' }}
                  />
                  
                  <Button 
                    variant="contained" 
                    size="large"
                    onClick={() => {
                      handleClickOpen();
                      settraderId(trader.id);
                      setSelectedtrader(trader);
                      setAmount(parseFloat(trader.min_amount))
                    }}
                    sx={{ 
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      px: 4,
                      py: 1.5,
                      background: 'linear-gradient(45deg, #22c55e, #16a34a)',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #16a34a, #15803d)'
                      }
                    }}
                  >
                    Invest Now
                  </Button>
                </Box>

                {/* Project Description */}
                {trader.description && (
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6, textAlign: 'center' }}>
                    {trader.description}
                  </Typography>
                )}

                {/* Key Metrics Grid */}
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center', p: 2, borderRadius: '12px', bgcolor: 'rgba(34, 197, 94, 0.1)' }}>
                      <TrendingUpIcon sx={{ fontSize: 32, color: '#22c55e', mb: 1 }} />
                      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#22c55e' }}>
                        {trader.gain}%
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Expected Return
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center', p: 2, borderRadius: '12px', bgcolor: 'rgba(59, 130, 246, 0.1)' }}>
                      <GroupIcon sx={{ fontSize: 32, color: '#3b82f6', mb: 1 }} />
                      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#3b82f6' }}>
                        {formatInvestors(trader.copiers)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Active Investors
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center', p: 2, borderRadius: '12px', bgcolor: 'rgba(245, 158, 11, 0.1)' }}>
                      <ScheduleIcon sx={{ fontSize: 32, color: '#f59e0b', mb: 1 }} />
                      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#f59e0b' }}>
                        {trader.duration} 
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                         Duration (Days)
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center', p: 2, borderRadius: '12px', bgcolor: 'rgba(168, 85, 247, 0.1)' }}>
                      <AttachMoneyIcon sx={{ fontSize: 32, color: '#a855f7', mb: 1 }} />
                      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#a855f7' }}>
                        {formatPrice(trader.min_amount)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Min Investment
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Performance Chart */}
            <Card sx={{ mb: 3, borderRadius: '16px' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                  Investment Performance History
                </Typography>
                <ReactApexChart
                  options={options}
                  series={[{
                    name: 'Return',
                    data: getSeriesdata(parseFloat(trader.gain))
                  }]}
                  type="area"
                  height={300}
                />
              </CardContent>
            </Card>

            {/* Tabs Section */}
            <Card sx={{ borderRadius: '16px' }}>
              <CardContent sx={{ p: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={value} onChange={handleChange} aria-label="investment tabs" centered>
                    <Tab label="Investment Summary" {...a11yProps(0)} />
                  </Tabs>
                </Box>

                <CustomTabPanel value={value} index={0}>
                  <Box sx={{ p: 3 }}>
                    <Card sx={{ borderRadius: '12px' }}>
                      <CardContent sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                          <BusinessCenterIcon color="primary" />
                          Performance Metrics
                        </Typography>
                        
                        <Box sx={{ mb: 3 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              ROI ({trader.duration})
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#22c55e' }}>
                              {trader.gain}%
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              Active Investors
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                              {formatInvestors(trader.copiers)}
                            </Typography>
                          </Box>
                        </Box>
                        
                        <Box sx={{ mb: 3 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              Total Profit
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#22c55e' }}>
                              {formatPrice(trader.profit)}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2" color="text.secondary">
                              Total Loss
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#f44336' }}>
                              {formatPrice(trader.loss)}
                            </Typography>
                          </Box>
                        </Box>
                        
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Success Rate
                          </Typography>
                          <LinearProgress 
                            variant="determinate" 
                            value={calcPercentage(trader.profit, trader.loss)} 
                            sx={{ height: 8, borderRadius: 4 }}
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                </CustomTabPanel>
              </CardContent>
            </Card>

            {/* Investment Dialog */}
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
              maxWidth="sm"
              fullWidth
            >
              <DialogContent sx={{ p: 3 }}>
                <DialogContentText sx={{ textAlign: 'center', mb: 3 }} id="alert-dialog-slide-description">
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Start Your Investment
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Fill out the form below to begin your investment journey
                  </Typography>
                </DialogContentText>

                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                  <FormControl sx={{ m: 1, minWidth: '100%' }} size="medium">
                    <InputLabel htmlFor="proportion">Investment Multiplier</InputLabel>
                    {(error !== '' && error.duration) ? (
                      <OutlinedInput
                        error
                        value={proportion}
                        onChange={(e) => {
                          setAmount(e.target.value * selectedtrader.min_amount); 
                          setProportion(e.target.value)
                        }}
                        labelId="proportion"
                        id="proportion"
                        name="proportion"
                        type={'number'}
                        label={`Investment Multiplier`}
                        helperText={error.proportion}
                      />
                    ) : (
                      <OutlinedInput
                        onChange={(e) => {
                          setAmount(e.target.value * selectedtrader.min_amount); 
                          setProportion(e.target.value)
                        }}
                        value={proportion}
                        type={'number'}
                        labelId="proportion"
                        name="proportion"
                        id="proportion"
                        label={`Investment Multiplier`}
                      />
                    )}
                    <Typography color='error' sx={{ textAlign: 'left', fontSize: 14 }} variant="body2" gutterBottom>
                      {error !== '' && error.duration}
                    </Typography>
                  </FormControl>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 2 }}>
                    <Chip label="1X" onClick={() => {setAmount(selectedtrader.min_amount); setProportion(1)}} />
                    <Chip label="2X" onClick={() => {setAmount(selectedtrader.min_amount * 2); setProportion(2)}} />
                    <Chip label="3X" onClick={() => {setAmount(selectedtrader.min_amount * 3); setProportion(3)}} />
                    <Chip label="4X" onClick={() => {setAmount(selectedtrader.min_amount * 4); setProportion(4)}} />
                    <Chip label="5X" onClick={() => {setAmount(selectedtrader.min_amount * 5); setProportion(5)}} />
                  </Box>

                  <FormControl sx={{ m: 1, minWidth: '100%' }} size="medium">
                    <InputLabel htmlFor="amount">Investment Amount</InputLabel>
                    <OutlinedInput
                      readOnly
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      id="amount"
                      type={'number'}
                      label="Investment Amount"
                    />
                  </FormControl>
                
                  <FormControl sx={{ m: 1, minWidth: '100%' }} size="medium">
                    <InputLabel htmlFor="source">Select Payment Source</InputLabel>
                    {(error !== '' && error.source) ? (
                      <Select
                        error
                        onChange={(e) => {
                          setSource(e.target.value)
                          getCoinDetails(e.target.value)
                        }}
                        labelId="source"
                        id="source"
                        name="source"
                        label={`Select Payment Source`}
                        helperText={error.source}
                      >
                        <MenuItem selected value=''>
                          Select Gateway
                        </MenuItem> 
                        <MenuItem selected value="Overall Asset">
                          Overall Asset (Bal = {formatPrice(fundingBal)})
                        </MenuItem>
                      </Select>
                    ) : (
                      <Select
                        onChange={(e) => {
                          setSource(e.target.value)
                          getCoinDetails(e.target.value)
                        }}
                        labelId="source"
                        name="source"
                        id="source"
                        label={`Select Payment Source`}
                      >
                        <MenuItem selected value=''>
                          Select Gateway
                        </MenuItem> 
                        <MenuItem selected value="Overall Asset">
                          Overall Asset (Bal = {formatPrice(fundingBal)})
                        </MenuItem>
                      </Select>
                    )}
                    <Typography color='error' sx={{ textAlign: 'left', fontSize: 14 }} variant="body2" gutterBottom>
                      {error !== '' && error.source}
                    </Typography>
                  </FormControl>

                  {selectedCoin !== null && (
                    <Fragment>
                      <Alert severity="info" sx={{ borderRadius: '8px' }}>
                        {selectedCoin.wallet_type === 'bank' ?
                          `Kindly make payment to our ${selectedCoin.coin_name} account using the details below`
                          : 
                          `Kindly send ${formatPrice(amount)} worth of ${selectedCoin.coin_name} to the provided address below.`
                        }
                      </Alert>    

                      {selectedCoin.wallet_type === 'Crypto' && (
                        <Box my={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <QRCode 
                            qrStyle="dots" 
                            value={selectedCoin.address} 
                            size={200}
                            logoImage={``}
                          />
                        </Box>
                      )}

                      <Box my={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CopyToClipboard 
                          onCopy={() => {
                            setbuttonText(selectedCoin.wallet_type === 'bank'? 'Account Details Copied' : 'Address Copied');
                            setTimeout(() => {
                              setbuttonText(null);
                            }, 2000);
                          }} 
                          text={selectedCoin.address}
                        >
                          <FormControl fullWidth={true} sx={{ minWidth: 50, marginBottom: 2 }}>
                            <TextField
                              minRows={1} 
                              multiline
                              defaultValue={selectedCoin.address}
                              id="address"
                              name="address"
                              type={'text'}
                              label={buttonText !== null? buttonText: `Click to copy ${selectedCoin.coin_name} ${selectedCoin.wallet_type === 'bank'? 'bank details' : 'address'}`}
                            />
                          </FormControl> 
                        </CopyToClipboard>
                      </Box>
                    </Fragment>
                  )}
                </Box> 

                <Button 
                  onClick={postInvestment} 
                  fullWidth={true} 
                  size="large" 
                  color="primary" 
                  variant="contained"
                  sx={{ 
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    py: 1.5,
                    background: 'linear-gradient(45deg, #22c55e, #16a34a)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #16a34a, #15803d)'
                    }
                  }}
                > 
                  {isInvesting ? 'Processing Investment...' : 'Start Investment'}  
                </Button>      
              </DialogContent>
            </Dialog>
          </Fragment>
        ))}
      </Box>
    </div>
  )
}

export default TraderSingle
